import React, { useState } from "react";
import axios from "axios";
import { Row, Col, Card, Container, ListGroup, Form, Button } from "react-bootstrap";
import Message from "../../../utilityComponents/Message";
import MiniLoader from "../../../utilityComponents/MiniLoader";


const MapAdUpload = () => {
    const [fileSystem, setFileSystem] = useState("s3-filesystem");
    const [message_map, setMessageMap] = useState("");
    const [loader, setLoader] = useState(false);
    const [errorMessageMap, setErrorMessageMap] = useState("");

    const handleUpload = (ev) => {
        setLoader(true)
        ev.preventDefault();
        setMessageMap("");
        setErrorMessageMap("");
        const custom_map = document.getElementById("custom-maps");

        for (let i = 0; i < custom_map.files.length; i++) {
            const data = new FormData();
            data.append("custom_maps", custom_map.files[i]);
            data.append("file_system", fileSystem);
            axios
                .post("/upload/upload_custom_map", data)
                .then((response) => {
                    if (response.status === 200) {
                        const responseMessage = response.data.message;
                        setMessageMap(responseMessage);
                        setLoader(false)
                        custom_map.value = "";
                    }
                })
                .catch((error) => {
                    setErrorMessageMap(error.message);
                    setLoader(false)
                    custom_map.value = "";
                });
        }

        // custom_map.value = "";
    };

    const availableFileSystems = [
        {
            label: "S3-FileSystem",
            value: "s3-filesystem",
        },
        {
            label: "Local-FileSystem",
            value: "local-filesystem",
        },
    ];

    return (
        <>
            <Container data-test="mapAdComponent" className="mt-5">
                <Row>
                    <Col>
                        <Card>
                            <Card.Header className="mb-2" style={{ backgroundColor: "#757AF7" }}>
                                <Row>
                                    <Col md={9} sm={5}>
                                        <h4 style={{ color: "#FFFFFF" }}>Upload Custom map</h4>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                <Form onSubmit={handleUpload}>
                                    {message_map && <Message variant="info">{message_map}</Message>}
                                    {loader ? <MiniLoader/> : undefined}
                                    {errorMessageMap && (
                                        <Message variant="danger">{errorMessageMap}</Message>
                                    )}
                                    <Row>
                                        <Col>
                                            <Card>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <h4> Custom Map :</h4>
                                                        </Col>
                                                        <Col>
                                                            <input
                                                                type="file"
                                                                multiple
                                                                id="custom-maps"
                                                                required
                                                            />
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>                                                
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <h4>File System :</h4>
                                                        </Col>
                                                        <Col>
                                                            <Form.Control
                                                                as="select"
                                                                required
                                                                value={fileSystem}
                                                                onChange={(e) =>
                                                                    setFileSystem(e.target.value)
                                                                }
                                                            >
                                                                {availableFileSystems.map(
                                                                    (item, index) => (
                                                                        <option
                                                                            key={`file-system-${index}`}
                                                                            value={item.value}
                                                                        >
                                                                            {item.label}
                                                                        </option>
                                                                    )
                                                                )}
                                                            </Form.Control>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col>
                                            <ListGroup.Item>
                                                <Row>
                                                    <Col className="text-center">
                                                        <Button
                                                            type="submit"
                                                            style={{
                                                                backgroundColor: "#757AF7",
                                                                color: "#FFFFFF",
                                                            }}
                                                        >
                                                            Upload
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </ListGroup.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
export default MapAdUpload;
